'use client';
import { hideModal } from '@/redux/navigationSlice';
import { Button, Stack } from '@mui/material';
import { Doodles } from '@repo/ui';
import { useRouter } from 'next/navigation';
import { useDispatch } from 'react-redux';

/**
 * Renders a close session body for a Modal component.
 *
 * @return {React.JSX.Element} The rendered CloseSessionBody component.
 */
export const CloseSessionBody = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const router = useRouter();
  return (
    <>
      <Doodles type="confirmation" />
      <Stack direction="row" gap={2} width="100%" mt={2}>
        <Button fullWidth variant="outlined" onClick={() => dispatch(hideModal())}>
          Cancelar
        </Button>
        <Button
          fullWidth
          onClick={(e) => {
            e.preventDefault();
            router.push('/login');
            router.refresh();
            dispatch(hideModal());
          }}
        >
          Confirmar
        </Button>
      </Stack>
    </>
  );
};
